import React, { useEffect, useState } from 'react';

const Vh100Context = React.createContext(null);

export function Vh100ContextProvider(props) {
    const height = use100vh();
    return <Vh100Context.Provider value={height} {...props} />;
}

export function use100vh(): number | null {
    const [height, setHeight] = useState<number | null>(measureHeight);
    useEffect(() => {
        function setMeasuredHeight() {
            const measuredHeight = measureHeight();
            setHeight(measuredHeight);
        }

        window.addEventListener('resize', setMeasuredHeight);
        return () => window.removeEventListener('resize', setMeasuredHeight);
    }, []);
    return height;
}

function measureHeight(): number | null {
    return document.documentElement?.clientHeight || window.innerHeight;
}

export default Vh100Context;
